import { makeStyles } from '@mui/styles';

const useLoginStyle = makeStyles({
    loginContainer:{
        minHeight: '100vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        // padding: "0px 12px"
      },
      
      loginPaper:{
        padding: "32px",
        width: "100%",
        maxWidth: "310px"
      },
      
      loginTitle:{
        fontWeight: '600 !important',
        textAlign: "center",
        marginBottom: "16px"
      },
      
      loginSubtext:{
        color: "red",
        textAlign: "center",
        marginBottom: "8px"
      },
      
      loginButton:{
        background:'#4565B7 !important',
        textTransform: "none !important",
        padding:'1rem !important',
        fontSize:'1rem !important',
        fontWeight:'600 !important'
      },
       versionText: {
    position: "absolute !important",
    bottom: "10px !important",
    right: "10px !important",
    fontSize: "0.75rem !important",
    color: "#9E9E9E !important",
  },
      
});

export default useLoginStyle;
